import src from "IMAGE";
export default { src, width: 625, height: 163, blurWidth: 0, blurHeight: 0};
